var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nights-flight-details-modal-component"},[_c('v-card',{staticClass:"border-none"},[_c('v-card-text',{staticClass:"no-padding-card"},[_c('pack-flights-wrapper')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }